export const getDefaultValues = () => ({
    employee_name: "",
    mobile: "",
    alternative_mobile: "",
    father_name: "",
    dob: "",
    state: "",
    city_id: "",
    country: "",
    email: "",
    gender: "",
    marital_status_id: "",
    permanent_address: "",
    present_address: "",
    proof_type_id: "",
    proof_number: "",
    pan_no: "",
    designation_id: "",
    department_id: "",
    employment_type_id: "",
    date_of_joining: "",
    employee_photo: null,
    id_proof_front: null,
    id_proof_back: null,
    attachments: [],
    educations: [
        {
            institute_name: "",
            education_level_id: "",
            start_date: "",
            end_date: "",
        },
    ],
    professionals: [
        {
            company_name: "",
            designation: "",
            ctc: "",
            start_date: "",
            end_date: "",
        },
    ],
    bank_name: "",
    ifsc_code: "",
    account_holder_name: "",
    account_no: "",
    branch: "",
    basic: "",
    hra: "",
    other_allowances: "",
    employee_pf: "",
    professional_tax: "",
    employer_pf: "",
    gross_pay: 0,
    net_pay: 0,
});

export const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    try {
        const date = new Date(dateString);
        return date.toISOString().split("T")[0];
    } catch (e) {
        return "";
    }
};

export const mapEditDataToFormData = (editData, proofTypes = []) => {
    if (!editData || !editData.data || !editData.data[0]) {
        return getDefaultValues();
    }

    const employeeData = editData.data[0];
    const selectedProof = proofTypes.find(p => p.value === employeeData.proof_type_id);

    return {
        employee_name: employeeData.name || "",
        mobile: employeeData.mobile || "",
        alternative_mobile: employeeData.alternate_mobile || "",
        father_name: employeeData.father_name || "",
        dob: formatDateForInput(employeeData.dob),
        country: employeeData.country_id || "",
        state: employeeData.state_id || "",
        city_id: employeeData.city_id || "",
        email: employeeData.email || "",
        gender: employeeData.gender || "Male",
        marital_status_id: employeeData.marital_status_id || 1,
        permanent_address: employeeData.permanent_address || "",
        present_address: employeeData.present_address || "",
        proof_type_id: selectedProof ? selectedProof.label : "",
        proof_number: employeeData.proof_number || "",
        pan_no: employeeData.pan || "",
        designation_id: employeeData.designation_id || "",
        department_id: employeeData.department_id || "",
        employment_type_id: employeeData.employment_type_id || "",
        date_of_joining: formatDateForInput(employeeData.date_of_joining),

        employee_photo: employeeData.employee_photo || null,
        id_proof_front: employeeData.id_proof_front || null,
        id_proof_back: employeeData.id_proof_back || null,
        attachments: [],

        educations:
            employeeData.education_info && employeeData.education_info.length > 0
                ? employeeData.education_info.map((edu) => ({
                    institute_name: edu.institute_name || "",
                    education_level_id: edu.education_level_id || "",
                    start_date: formatDateForInput(edu.start_date),
                    end_date: formatDateForInput(edu.end_date),
                }))
                : [
                    {
                        institute_name: "",
                        education_level_id: "",
                        start_date: "",
                        end_date: "",
                    },
                ],

        professionals:
            employeeData.professional_info &&
                employeeData.professional_info.length > 0
                ? employeeData.professional_info.map((prof) => ({
                    company_name: prof.company_name || "",
                    designation: prof.designation || "",
                    ctc: prof.ctc ? prof.ctc.toString() : "",
                    start_date: formatDateForInput(prof.start_date),
                    end_date: formatDateForInput(prof.end_date),
                }))
                : [
                    {
                        company_name: "",
                        designation: "",
                        ctc: "",
                        start_date: "",
                        end_date: "",
                    },
                ],

        bank_name: employeeData.bank?.bank_name || "",
        ifsc_code: employeeData.bank?.ifsc_code || "",
        account_holder_name: employeeData.bank?.account_holder_name || "",
        account_no: employeeData.bank?.account_number || "",
        branch: employeeData.bank?.branch_name || "",

        basic: employeeData.salary?.basic
            ? employeeData.salary.basic.toString()
            : "",
        hra: employeeData.salary?.hra ? employeeData.salary.hra.toString() : "",
        other_allowances: employeeData.salary?.other_allowances
            ? employeeData.salary.other_allowances.toString()
            : "",
        employee_pf: employeeData.salary?.employee_pf
            ? employeeData.salary.employee_pf.toString()
            : "",
        professional_tax: employeeData.salary?.professional_tax
            ? employeeData.salary.professional_tax.toString()
            : "",
        employer_pf: employeeData.salary?.employer_pf
            ? employeeData.salary.employer_pf.toString()
            : "",
        gross_pay: employeeData.salary?.gross_pay
            ? parseFloat(employeeData.salary.gross_pay)
            : 0,
        net_pay: employeeData.salary?.net_pay
            ? parseFloat(employeeData.salary.net_pay)
            : 0,
    };
};

export const transformDataForSubmit = (data, proofTypes) => {
    return {
        personalInfo: {
            name: data.employee_name?.trim(),
            father_name: data.father_name?.trim(),
            dob: data.dob,
            mobile: data.mobile,
            alternate_mobile: data.alternative_mobile || null,
            email: data.email?.trim(),
            marital_status_id: parseInt(data.marital_status_id) || null,
            country_id: parseInt(data.country) || null,
            state_id: parseInt(data.state) || null,
            city_id: parseInt(data.city_id) || 1,
            proof_type_id: proofTypes.find(p => p.label === data.proof_type_id)?.value || 5,
            designation_id: parseInt(data.designation_id) || null,
            department_id: parseInt(data.department_id) || null,
            employment_type_id: parseInt(data.employment_type_id) || null,
            permanent_address: data.permanent_address?.trim(),
            present_address: data.present_address?.trim(),
            proof_number: data.proof_number?.trim(),
            pan: data.pan_no?.trim(),
            date_of_joining: data.date_of_joining,
            gender: data.gender?.trim() || "Male",
        },
        education: Array.isArray(data.educations)
            ? data.educations
                .filter((edu) => edu.education_level_id && edu.institute_name)
                .map((edu) => ({
                    institute_name: edu.institute_name?.trim(),
                    education_level_id: parseInt(edu.education_level_id),
                    start_date: edu.start_date || null,
                    end_date: edu.end_date || null,
                }))
            : [],
        experience: Array.isArray(data.professionals)
            ? data.professionals
                .filter((prof) => prof.company_name && prof.designation)
                .map((prof) => ({
                    company_name: prof.company_name?.trim(),
                    designation: prof.designation?.trim(),
                    ctc: parseFloat(prof.ctc) || 0,
                    start_date: prof.start_date || null,
                    end_date: prof.end_date || null,
                }))
            : [],
        salary: {
            basic: parseFloat(data.basic) || 0,
            hra: parseFloat(data.hra) || 0,
            other_allowances: parseFloat(data.other_allowances) || 0,
            gross_pay:
                (parseFloat(data.basic) || 0) +
                (parseFloat(data.hra) || 0) +
                (parseFloat(data.other_allowances) || 0),
            employee_pf: parseFloat(data.employee_pf) || 0,
            professional_tax: parseFloat(data.professional_tax) || 0,
            net_pay:
                (parseFloat(data.basic) || 0) +
                (parseFloat(data.hra) || 0) +
                (parseFloat(data.other_allowances) || 0) -
                ((parseFloat(data.employee_pf) || 0) + (parseFloat(data.professional_tax) || 0)),
            employer_pf: parseFloat(data.employer_pf) || 0,
        },
        bankDetails: {
            bank_name: data.bank_name?.trim(),
            account_number: data.account_no?.toString().trim(),
            ifsc_code: data.ifsc_code?.trim(),
            account_holder_name: data.account_holder_name?.trim(),
            branch_name: data.branch?.trim() || "",
        },
    };
};
